import { DYNAMIC_360_GOAL_IDS, FEEDBACK_360_SURVEY } from "../../../../../config/questionTypeConstants"
import { deepCopy } from "../../../../utils/deepCopy"
import { checkIfJson } from "../../../../utils/newAttendSurveyUtils"
import { STRENGTH_VALUES } from "../constants"

export const onChangeTableMatrix = (state, payload) => {
    let updatedQuestionSet = getAnsweredGoal(state, payload)
    return {
        ...state,
        questionSet: updatedQuestionSet.questionSetCopy,
        pageBreakAddedQuestionSet:updatedQuestionSet.pageBreakBlockCopy
    }
}
const getAnsweredGoal = (state, payload) => {
    let questionSetCopy = deepCopy(state.questionSet)
    let pageBreakBlockCopy = deepCopy(state.pageBreakAddedQuestionSet)
    let answer = []

    questionSetCopy.forEach((item, index) => {
        if (item.blockId === payload.blockId) {
            item.questions.forEach(question => {
                question.answer = JSON.stringify(generateAnswer(question, payload))
                answer = JSON.stringify(generateAnswer(question, payload))
                if (item.goalId === DYNAMIC_360_GOAL_IDS.STRENGTH || item.goalId === DYNAMIC_360_GOAL_IDS.STRENGTH_180) {
                    let findedDragIndex = pageBreakBlockCopy.findIndex((item) => item.goalId === DYNAMIC_360_GOAL_IDS.STRENGTH_DRAG ||item.goalId === DYNAMIC_360_GOAL_IDS.STRENGTH_DRAG_180)
                    let findedImprovementDragIndex = pageBreakBlockCopy.findIndex((item) => item.goalId === DYNAMIC_360_GOAL_IDS.IMPROVEMENT_DRAG || item.goalId === DYNAMIC_360_GOAL_IDS.IMPROVEMENT_DRAG_180)
                    let questionBlockStrength = pageBreakBlockCopy[findedDragIndex].questions[0] ? pageBreakBlockCopy[findedDragIndex].questions[0] : {}
                    let questionBlockImprovement=pageBreakBlockCopy[findedImprovementDragIndex].questions[0]?pageBreakBlockCopy[findedImprovementDragIndex].questions[0]:{}
                    let questionSetBlockStrength = questionSetCopy[findedDragIndex].questions[0] ? questionSetCopy[findedDragIndex].questions[0] : {}
                    let questionSetBlockImprovement = questionSetCopy[findedImprovementDragIndex].questions[0] ? questionSetCopy[findedImprovementDragIndex].questions[0] : {}
                    let answeredRadioObject = payload.answeredRadio;
                    Object.keys(questionBlockImprovement).map(item=>{
                        Array.isArray(questionBlockImprovement[item].questions) && questionBlockImprovement[item].questions.map((question,id)=>{
                            if(payload.answeredRadio.rowId===question.id){
                                questionBlockImprovement[item].questions.splice(id,1)
                                questionSetBlockImprovement[item].questions.splice(id, 1)
                            }
                        })
                        if(questionBlockImprovement[item].questions && questionBlockImprovement[item].questions.length==0){
                            delete questionBlockImprovement[item];
                            delete questionSetBlockImprovement[item];
                        }
                    })

                    Object.keys(questionBlockStrength).map(item=>{
                        Array.isArray(questionBlockStrength[item].questions) && questionBlockStrength[item].questions.map((question,id)=>{
                            if(payload.answeredRadio.rowId===question.id){
                                questionBlockStrength[item].questions.splice(id,1)
                                questionSetBlockStrength[item].questions.splice(id, 1)
                            }
                        })
                        if(questionBlockStrength[item].questions && questionBlockStrength[item].questions.length==0){
                            delete questionBlockStrength[item];
                            delete questionSetBlockStrength[item];
                        }
                    })
                    if (pageBreakBlockCopy[findedDragIndex].questions && pageBreakBlockCopy[findedDragIndex].questions[0] && pageBreakBlockCopy[findedDragIndex].questions[0].answer) {
                        if (checkAnswerRearrangementNeeded(pageBreakBlockCopy[findedDragIndex].questions[0], answeredRadioObject.rowId)) {
                            questionBlockStrength.answer = JSON.stringify([])
                            let findedComments = pageBreakBlockCopy.findIndex((item) => item.goalId === FEEDBACK_360_SURVEY.COMMENTS_ON_STRENGTH)
                            let questionArray = pageBreakBlockCopy[findedDragIndex].questions[0] && pageBreakBlockCopy[findedDragIndex].questions[0].answer ? JSON.parse(pageBreakBlockCopy[findedDragIndex].questions[0].answer) : []
                            let updatedQuestionsArray = questionArray.map((item) => {
                                return {
                                    id: item.id,
                                    label: item.label,
                                    question: item.question,
                                    questionDimension: item.questionDimension,
                                    selectedLabelAswer: item.selectedLabelAswer,
                                    staticQuestionId: item.staticQuestionId,
                                    priorityValue: item.answer,
                                    type: "Text Entry",
                                    englishQuestion: item.question,
                                    qid: item.id,
                                    answer: ""
                                }
                            })
                            pageBreakBlockCopy[findedComments].questions = updatedQuestionsArray
                        }
                    }
                    if (pageBreakBlockCopy[findedImprovementDragIndex].questions && pageBreakBlockCopy[findedImprovementDragIndex].questions[0] && pageBreakBlockCopy[findedImprovementDragIndex].questions[0].answer) {
                        if (checkAnswerRearrangementNeeded(pageBreakBlockCopy[findedImprovementDragIndex].questions[0], answeredRadioObject.rowId)) {
                            questionBlockImprovement.answer = JSON.stringify([])
                            let findedCommentsDragIndex = pageBreakBlockCopy.findIndex((item) => item.goalId === FEEDBACK_360_SURVEY.COMMENTS_ON_IMPROVEMENT)
                            let questionArray = pageBreakBlockCopy[findedImprovementDragIndex].questions[0] && pageBreakBlockCopy[findedImprovementDragIndex].questions[0].answer ? JSON.parse(pageBreakBlockCopy[findedImprovementDragIndex].questions[0].answer) : []
                            let updatedQuestionsArray = questionArray.map((item) => {
                                return {
                                    id: item.id,
                                    label: item.label,
                                    question: item.question,
                                    questionDimension: item.questionDimension,
                                    selectedLabelAswer: item.selectedLabelAswer,
                                    staticQuestionId: item.staticQuestionId,
                                    priorityValue: item.answer,
                                    type: "Text Entry",
                                    englishQuestion: item.question,
                                    qid: item.id,
                                    answer: ""
                                }
                            })
                            pageBreakBlockCopy[findedCommentsDragIndex].questions = updatedQuestionsArray
                            pageBreakBlockCopy[findedImprovementDragIndex].questions[0] = questionBlockImprovement
                            questionSetCopy[findedImprovementDragIndex].questions[0] = questionBlockImprovement
                        }
                    }
                    if (answeredRadioObject.columnId !== "0") {
                    if (answeredRadioObject.columnId === "3" || answeredRadioObject.columnId === "4")
                    {
                    if (pageBreakBlockCopy[findedDragIndex].questions) {

                        let columnId = payload.answeredRadio.columnId;
                        if (!questionBlockStrength[columnId]) {
                            questionBlockStrength[columnId] = {
                                answerLabel: answeredRadioObject.label,
                                questions: [{ question: answeredRadioObject.question,
                                             label: answeredRadioObject.label,
                                             selectedLabelAswer:columnId,
                                            id: answeredRadioObject.rowId,
                                    questionDimension: answeredRadioObject.questionDimension,
                                    staticQuestionId: answeredRadioObject.staticQuestionId
                                        }]
                            };
                        }
                        else {
                            questionBlockStrength[columnId]={...questionBlockStrength[columnId],questions:[...questionBlockStrength[columnId].questions]}
                            questionBlockStrength[columnId].questions.push({ question: answeredRadioObject.question,
                                label: answeredRadioObject.label, selectedLabelAswer: columnId, id: answeredRadioObject.rowId, questionDimension: answeredRadioObject.questionDimension, staticQuestionId: answeredRadioObject.staticQuestionId
                            })
                        }
                        pageBreakBlockCopy[findedDragIndex].questions[0] = questionBlockStrength
                        questionSetCopy[findedDragIndex].questions[0] = questionBlockStrength
                    }
                }
                    else {
                    if (pageBreakBlockCopy[findedImprovementDragIndex].questions) {
                        let columnId = payload.answeredRadio.columnId;

                        if (!questionBlockImprovement[columnId]) {
                            questionBlockImprovement[columnId] = {
                                answerLabel: answeredRadioObject.label,
                                questions: [{ question: answeredRadioObject.question,
                                             label: answeredRadioObject.label,
                                             selectedLabelAswer:columnId,
                                            id: answeredRadioObject.rowId,
                                    questionDimension: answeredRadioObject.questionDimension,
                                    staticQuestionId: answeredRadioObject.staticQuestionId
                                        }]
                            };
                        }
                        else{
                            
                            questionBlockImprovement[columnId]={...questionBlockImprovement[columnId],questions:[...questionBlockImprovement[columnId].questions]}
                            questionBlockImprovement[columnId].questions.push({ question: answeredRadioObject.question,
                                label: answeredRadioObject.label, selectedLabelAswer: columnId, id: answeredRadioObject.rowId, questionDimension: answeredRadioObject.questionDimension, staticQuestionId: answeredRadioObject.staticQuestionId
                            })
                        }
                        pageBreakBlockCopy[findedImprovementDragIndex].questions[0] = questionBlockImprovement
                        questionSetCopy[findedImprovementDragIndex].questions[0] = questionBlockImprovement
                        questionSetCopy[findedDragIndex].questions[0] = questionBlockStrength
                        pageBreakBlockCopy[findedDragIndex].questions[0] = questionBlockStrength
                    }
                }
                    }
                    else {
                        pageBreakBlockCopy[findedDragIndex].questions[0] = questionBlockStrength
                        pageBreakBlockCopy[findedImprovementDragIndex].questions[0] = questionBlockImprovement
                        questionSetCopy[findedImprovementDragIndex].questions[0] = questionBlockImprovement
                        questionSetCopy[findedDragIndex].questions[0] = questionBlockStrength
                    }
                }
            });

        }

    });

    return { questionSetCopy, pageBreakBlockCopy };
};

const generateAnswer = (currentQuestion, payload) => {
    let answeredRadio = payload.answeredRadio
    let answer = []
    if (currentQuestion.answer && currentQuestion.answer.length > 0) {
        answer = JSON.parse(currentQuestion.answer)
        let rowAnsweredIndex = answer.findIndex((item) => item.rowId === answeredRadio.rowId)
        if (rowAnsweredIndex !== -1) {
            answer[rowAnsweredIndex] = answeredRadio
        }
        else {
            answer.push(answeredRadio)
        }
    }
    else {
        answer.push(answeredRadio)

    }
    return answer

}

const checkAnswerRearrangementNeeded = (currentContent, rowId) => {
    if (checkIfJson(currentContent.answer)) {
        let parsedAnswer = JSON.parse(currentContent.answer)
        let findAnswer = parsedAnswer.find((item) => item.id === rowId)
        if (findAnswer) {
            return true
        }
        else {
            return false
        }

    }
}
